import { mockUsers, updateMockUsers, generateUserId } from './mockData';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// --- User Service ---

export const getUsers = async (params = {}) => {
    await delay(400);
    let filteredUsers = [...mockUsers]; // Work with a copy

    // Mock Search
    if (params.search) {
        const searchTerm = params.search.toLowerCase();
        filteredUsers = filteredUsers.filter(u =>
            u.name.toLowerCase().includes(searchTerm) ||
            u.email.toLowerCase().includes(searchTerm) ||
            u.role.toLowerCase().includes(searchTerm)
        );
    }

    // Mock Sorting (basic example for name)
    if (params.sortField === 'name') {
        filteredUsers.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (params.sortOrder === 'ascend') {
                return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            } else { // descend
                return nameB < nameA ? -1 : nameB > nameA ? 1 : 0;
            }
        });
    }
     // Add more sorting for email, role, createdAt

    // Mock Pagination (very basic)
    const page = params.page || 1;
    const pageSize = params.pageSize || 10;
    const startIndex = (page - 1) * pageSize;
    const paginatedUsers = filteredUsers.slice(startIndex, startIndex + pageSize);

    return {
        data: paginatedUsers,
        total: filteredUsers.length, // Total matching search/filters
    };
};

export const addUser = async (userData) => {
    await delay(300);
    if (!userData.name || !userData.email || !userData.role || !userData.password) {
        throw new Error("Missing required user fields");
    }
    if (mockUsers.some(u => u.email === userData.email)) {
        throw new Error('Email already exists');
    }
    // In real app, hash password here
    const newUser = {
        ...userData,
        id: generateUserId(),
        createdAt: new Date(),
    };
    const updatedUsers = [...mockUsers, newUser];
    updateMockUsers(updatedUsers); // Update the original array if export method is used
    return newUser;
};

export const updateUser = async (userId, updatedData) => {
    await delay(300);
    const userIndex = mockUsers.findIndex(u => u.id === userId);
    if (userIndex === -1) {
        throw new Error("User not found");
    }
    // Prevent changing email if it already exists for another user
    if (updatedData.email && mockUsers.some(u => u.email === updatedData.email && u.id !== userId)) {
         throw new Error('Email already exists for another user');
    }

    // Don't update password if it's not provided or empty
    const dataToUpdate = { ...updatedData };
    if (!dataToUpdate.password) {
        delete dataToUpdate.password;
    } else {
        // In real app, hash the new password here
    }


    const updatedUser = { ...mockUsers[userIndex], ...dataToUpdate };
    const updatedUsersList = [...mockUsers];
    updatedUsersList[userIndex] = updatedUser;
    updateMockUsers(updatedUsersList); // Update the original array
    const { password, ...userWithoutPassword } = updatedUser; // Don't return password
    return userWithoutPassword;
};

export const deleteUser = async (userId) => {
    await delay(300);
    const initialLength = mockUsers.length;
    const updatedUsers = mockUsers.filter(u => u.id !== userId);
    if (updatedUsers.length === initialLength) {
         throw new Error("User not found for deletion");
    }
    updateMockUsers(updatedUsers); // Update the original array
    return { success: true, id: userId };
};